const zh = {
  home: '首页',
  examination: '考试',
  course: '课程',
  record: '记录',
  help: '帮助',
  register: '注册',
  login: '登录',
  usernamePasswordLogin: '账号密码登录',
  search: '搜索',
  reset: '重置',
  username: '账号',
  usernameOrEmail: '用户名',
  password: '密码',
  oldPassword: '旧密码',
  newPassword: '新密码',
  confirm: '确认',
  sure: '确定',
  cancel: '取消',
  tips: '提示',
  save: '保存',
  submit: '提交',
  submitJ: '交卷',
  confirmSubmit: '确定要提交吗？',
  tenantCode: '企业 ID',
  email: '邮箱',
  validationCode: '验证码',
  inputValidationCode: '请输入验证码',
  forgetPassword: '忘记密码？',
  smsCodeLogin: '短信验证码登录',
  phoneNumber: '手机号码',
  sendValidationCode: '发送验证码',
  send: '发送',
  cutdown: '{count}秒后重新获取',
  sendSuccess: '发送成功',
  registerSuccess: '注册成功',
  success: '成功',
  successAndExit: '成功，即将自动关闭页面',
  failed: '失败',
  operation: '操作',
  return: '返回',
  timeLeft: '剩余时间',
  load: {
    loadMore: '加载更多',
    loadFailed: '加载数据失败！',
    noMoreData: '暂无更多数据！',
    loading: '正在拼命加载！'
  },
  validate: {
    inputUsername: '请输入用户名',
    inputEmail: '请输入邮箱地址',
    inputPassword: '请输入密码',
    inputValidationCode: '请输入验证码',
    inputPhoneNumber: '请输入手机号码',
    usernameExists: '用户名已存在',
    inputPhoneLen: '请输入正确的 11 位手机号码',
    passwordMustFourLength: '密码长度最少为 4 位',
    validationCodeMustFourLength: '验证码长度为 4 位'
  },
  language: {
    zh: '中文',
    en: 'English'
  },
  common: {
    link: '链接',
    tool: '工具',
    community: '社区',
    gitee: '码云',
    github: 'Github',
    admin: '管理后台',
    changeLog: '更新日志',
    feedback: '反馈建议',
    contactUs: '联系我们',
    contactUsContent: '请联系 1633736729@qq.com',
    privacyPolicy: '隐私条款'
  },
  header: {
    sourceCode: '源码地址',
    document: '部署文档',
    changeLog: '更新日志',
    roadmap: '功能规划',
    admin: '管理后台',
    personal: '个人中心',
    changePwd: '修改密码',
    logout: '退出'
  },
  homePage: {
    startUsing: '开始使用',
    userCnt: '用户数',
    examinationCnt: '考试数',
    subjectCnt: '题目数',
    courseCnt: '课程数',
    popularCourses: '热门课程',
    loadFailed: '加载首页数据失败！',
    loadCoursesFailed: '加载热门课程数据失败！'
  },
  fav: {
    myFavorite: '我的收藏',
    favorite: '收藏',
    cancelFavorite: '取消收藏'
  },
  exam: {
    examinationName: '考试名称',
    examinationType: '考试类型',
    examinationTime: '考试时间',
    status: '状态',
    score: '成绩',
    scoreDetail: '成绩详情',
    scoreRank: '排行榜',
    examIntroduction: '考试介绍',
    examEvaluation: '考试评价',
    course: {
      searchPlaceholder: '搜索您感兴趣的课程',
      courseName: '课程名称',
      courseIntroduction: '课程介绍',
      chapter: '课程章节',
      courseEvaluation: '课程评价',
      inputEvaluation: '请输入评价内容',
      studyExchange: '学习交流',
      courseAttach: '课件',
      registerStudents: '报名学员',
      examinations: '课程考试',
      registerStudents1: '已报名学员',
      courseFeatures: '课程特色',
      learnHour: '课时',
      chapter1: '章节',
      memberCount: '学员数',
      evaluatesCount: '好评数',
      youMayAlsoLike: '猜你喜欢',
      hour: '小时',
      charge: '收费',
      free: '免费',
      registration: '报名',
      cancelRegistration: '取消报名',
      pleaseRegistration: '请先报名',
      startLearn: '开始学习',
      submitSuccess: '提交成功',
      submitFailed: '提交失败',
      doNotResubmit: '请勿重复提交',
      defaultEvaluate: '用户默认好评',
      demoCourseName: '应用文写作',
      courses: {
        popularCourses: '热门课程',
        registerStudentsCnt: '已报名学员人数',
        level: '难度等级'
      }
    },
    courses: {
      all: '全部',
      latestRelease: '最新发布'
    },
    records: {
      records: '考试记录'
    },
    exams: {
      examRemark: '考试介绍',
      examAttention: '注意事项',
      examTime: '考试时间',
      startTime: '开始时间：',
      examDuration: '考试时长：',
      unLimitTime: '无限制',
      all: '全部',
      latestRelease: '最新发布',
      mostClicks: '最多点击',
      parameters: '参数人数',
      end: '考试已结束',
      notStarted: '考试未开始',
      start: '开始考试',
      sureStart: '确定要开始吗？',
      startFailed: '开始考试失败',
      evaluation: '考试评价',
      inputEvaluation: '请输入评价内容',
      submitSuccess: '提交成功',
      doNotResubmit: '请勿重复提交',
      defaultEvaluate: '用户默认好评',
      unrelatedCourse: '无关联课程',
      withoutTimeLimit: '无时间限制',
      rank: '排名',
      account: '账号',
      score: '分数'
    },
    startExam: {
      last: '上一题',
      next: '下一题',
      progress: '进度',
      answerCard: '答题卡',
      isFirst: '已经是第一题了',
      isLast: '已经是最后一题了',
      getSubjectFailed: '获取题目失败',
      confirmExit: '确认退出吗？',
      startExam: '考试开始',
      subject: '题目数',
      score: '总分',
      answered: '已答',
      notAnswered: '未答'
    },
    incorrect: {
      userName: '考生姓名',
      score: '总得分',
      startTime: '开始时间',
      endTime: '结束时间',
      duration: '耗时',
      correctNumber: '正确题数',
      inCorrectNumber: '错误题数',
      subjectList: '错题列表',
      userAnswer: '考生答案',
      answer: '参考答案',
      analysis: '解析',
      right: '正确',
      wrong: '错误',
      loadSubjectFailed: '加载错题失败',
      operator: '评卷人：系统自动评分'
    },
    subject: {
      subjectTypeChoices: '单选题',
      subjectTypeMultiChoices: '多选题',
      subjectTypeJudgement: '判断题',
      subjectTypeShortAnswer: '简答题',
      subjectTypeFillBlank: '填空题',
      subjectTypeMaterial: '材料题',
      fillBlankAnswerPlaceholder: '多个填空的答案换行隔开'
    }
  },
  personal: {
    account: {
      identifier: '账号',
      name: '姓名',
      gender: '性别',
      born: '出生日期',
      phone: '电话号码',
      email: '邮箱',
      avatar: '头像',
      inputIdentifier: '请输入账号',
      modifySuccess: '修改成功',
      modifyFailed: '修改失败',
      avatarUploadSuccess: '头像上传成功',
      avatarUploadFailed: '头像上传失败',
      avatarUploadFormat: '上传头像图片只能是 jpg/png 格式！',
      avatarUploadSize: '上传头像图片大小不能超过 2MB!'
    },
    pwd: {
      oldPwd: '旧密码',
      newPwd: '新密码',
      confirmPwd: '确认新密码',
      inputNewPwd: '请输入新密码',
      inputOldPwd: '请输入旧密码',
      pwdLenTips: '密码不能小于 6 位',
      inputPwdAgain: '请再次输入密码',
      pwdNotEqual: '两次输入密码不一致！',
      modifySuccess: '修改成功',
      modifyFailed: '修改失败'
    }
  },
  status: {
    examination: '考试',
    practice: '练习',
    questionnaire: '问卷',
    interview: '面试',
    complete: '统计完成',
    markComplete: '已批改',
    todoMark: '待批改',
    right: '正确',
    wrong: '错误',
    men: '男',
    women: '女'
  },
  media: {
    audio: {
      progress: '进度条：',
      limit: '已达到播放次数限制',
      playFailed: '播放语音失败',
      play: '播放',
      pause: '暂停',
      muted: '静音',
      notMuted: '放音',
      transSpeed: '快进：x'
    },
    video: {
      playError: '此视频暂无法播放，请稍后再试'
    }
  },
  searchForm: {
    q: '请输入关键词',
    course: '课程',
    exam: '考试',
    other: '其它',
    searchSuccess: '搜索成功',
    searchFailed: '搜索失败'
  }
}

export default zh



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN/zh.js